import {
  GET_FEATURES,
  GET_FEATURES_FAIL,
  GET_FEATURES_SUCCESS,
  ADD_NEW_FEATURE,
  ADD_FEATURE_SUCCESS,
  ADD_FEATURE_FAIL,
  UPDATE_FEATURE,
  UPDATE_FEATURE_SUCCESS,
  UPDATE_FEATURE_FAIL,
  DELETE_FEATURE,
  DELETE_FEATURE_SUCCESS,
  DELETE_FEATURE_FAIL,
  
} from "./actionTypes";

export const getFeatures = () => ({
  type: GET_FEATURES,
})

export const getFeaturesSuccess = features => ({
  type: GET_FEATURES_SUCCESS,
  payload: features,
})

export const getFeaturesFail = error => ({
  type: GET_FEATURES_FAIL,
  payload: error,
})

export const addNewFeature = data => ({
  type: ADD_NEW_FEATURE,
  payload: data,
})

export const addFeatureSuccess = feature => ({
  type: ADD_FEATURE_SUCCESS,
  payload: feature,
})

export const addFeatureFail = error => ({
  type: ADD_FEATURE_FAIL,
  payload: error,
})

export const updateFeature = feature => ({
  type: UPDATE_FEATURE,
  payload: feature,
})

export const updateFeatureSuccess = feature => ({
  type: UPDATE_FEATURE_SUCCESS,
  payload: feature,
})

export const updateFeatureFail = error => ({
  type: UPDATE_FEATURE_FAIL,
  payload: error,
})

export const deleteFeature = data => ({
  type: DELETE_FEATURE,
  payload: data,
})

export const deleteFeatureSuccess = data => ({
  type: DELETE_FEATURE_SUCCESS,
  payload: data,
})

export const deleteFeatureFail = error => ({
  type: DELETE_FEATURE_FAIL,
  payload: error,
})

